const googleAttribution = '<b>NOT FOR PUBLIC USE</b> - Google Map data &copy;' + new Date().getFullYear() + ' | <a href="https://www.google.com/intl/en-US_US/help/terms_maps">Terms of Use</a>'

const providers: any = {
  'default': {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    opt: {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }
  },
  'osm': {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    opt: {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }
  },
  'carto-light': {
    url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
    opt: {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/attribution">CARTO</a>'
    }
  },
  'stadia-alidade_smooth_dark': {
    url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
    opt: {
      maxZoom: 20,
      attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
    }
  },
  // https://stackoverflow.com/questions/9394190/leaflet-map-api-with-google-satellite-layer
  // Note the difference in the "lyrs" parameter in the URL:
  // Hybrid: s,h;
  // Satellite: s;
  // Streets: m;
  // Terrain: p;
  'google-streets': {
    url: 'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
    opt: {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution: googleAttribution,
    }
  },
  'google-satellite': {
    url: 'http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    opt: {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution: googleAttribution,
    }
  },
  'google-hybrid': {
    url: 'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
    opt: {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution: googleAttribution,
    }
  },
  'google-terrain': {
    url: 'http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
    opt: {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution: googleAttribution,
    }
  },
  'google-traffic': {
    url: 'https://{s}.google.com/vt/lyrs=m@221097413,traffic&x={x}&y={y}&z={z}',
    opt: {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution: googleAttribution,
    }
  },
  // http://downloads2.esri.com/ArcGISOnline/docs/tou_summary.pdf
  'esry-world': {
    url: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    opt: {
      maxZoom: 18,
      attribution: '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
    }
  },
  // Vectors: https://www.komoot.it/plan/
  // // http://a.tile.komoot.de/komoot-2/{z}/{x}/{y}.png
  // // - https://github.com/komoot/staticmap/blob/master/staticmap/staticmap.py
  'komoot': {
    url: 'http://{s}.tile.komoot.de/komoot/{z}/{x}/{y}.png',
    opt: {
      maxZoom: 18,
      subdomains: ['a', 'b', 'c'],
      attribution: '&copy; <a href="http://www.komoot.de/">Komoot</a> | Map data &copy; OpenStreetMap contributors'
    },
  },
  'trz': {
    url: 'https://tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=<API_KEY>',
    opt: {
      maxZoom: 18,
      attribution: '&copy;',
    },
  },
  'thunderforest': {
    url: 'https://{s}.tile.thunderforest.com/spinal-map/{z}/{x}/{y}.png?apikey=<API_KEY>',
    opt: {
      maxZoom: 22,
      attribution: '&copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    },
  },
  // https://external.fcag1-1.fna.fbcdn.net/map_tile.php?v=1021&osm_provider=2&x=17217&y=12496&z=15&language=it_IT
  // https://external.fcag1-1.fna.fbcdn.net/map_tile.php?v=1021&osm_provider=2&x=4303&y=3123&z=13&language=it_IT
  // https://external.fcag1-1.fna.fbcdn.net/map_tile.php?v=1021&osm_provider=2&x=8606&y=6248&z=14&language=it_IT
  'fb': {
    url: 'https://external.fcag1-1.fna.fbcdn.net/map_tile.php?v=1021&osm_provider=2&x={x}&y={y}&z={z}&language=it_IT',
    opt: {
      maxZoom: 18,
      attribution: '&copy;',
    },
  },

  'local': {
    url: 'http://localhost:8989/{z}/{x}/{y}.png',
    opt: {
      maxZoom: 18,
      attribution: '&copy;',
    },
  },

  // http://a.tile.osm.org/10/538/392.png openrouteservice
}

export function LeafletTileProviders(name: string) {
  if (providers[name]) {
    return providers[name]
  } else {
    return providers['default']
  }
}

export function availableProviders() {
  return Object.keys(providers)
}
